import { CAT_NEWSLETTER_DOMAINS } from 'App/utils/Collections';
import { FT_SINGLE } from '../FilterTypes';

export const groups = {
  general: {
    name: 'General',
    groupOrderIndex: 3,
  },
};
export default {
  category: CAT_NEWSLETTER_DOMAINS,
  filters: [
    {
      id: 'id',
      label: 'ID Number',
      type: FT_SINGLE,
      group: groups.general,
      splittable: false,
    },
  ],
  searchBarProp: 'name',
};
